import git from "./git-version.json";
import pkg from './package.json';

export const versionInfo = (() => {
  return { "version" : pkg.version
         , "hash" : git.hash
         , "date" : git.date
         }
})();
